<section class="paraImage2">
  <div class="fundo">
    <h2><label>03</label> Minhas experiências</h2>
    <div class="timeline">
      <div class="timeline__event  animated fadeInUp delay-3s timeline__event--type1">
        <div class="timeline__event__icon ">
          <fa-icon [icon]="faBriefcase" class="lni-cake"></fa-icon>
        </div>
        <ng-container *ngFor="let item of actual_job" >
        <div class="timeline__event__date">
          <p>{{item.dataInicio}}</p>
            <p>até</p>
          <p>{{item.dataFim}}</p>
        </div>

          <div class="timeline__event__content ">
            <div class="timeline__event__title">
              {{item.empresa}}
            </div>
            <div class="timeline__event__description">
              <p>{{item.cargo}}</p>
              <ul class="box-text">
                <li>{{item.ocupacao_0.atividade}}<span> - {{item.ocupacao_0.tecnologia}}</span></li>
                <li>{{item.ocupacao_1.atividade}}<span> - {{item.ocupacao_1.tecnologia}}</span></li>
                <li>{{item.ocupacao_2.atividade}}<span> - {{item.ocupacao_2.tecnologia}}</span></li>
                <li>{{item.ocupacao_3.atividade}}<span> - {{item.ocupacao_3.tecnologia}}</span></li>
                <li>{{item.ocupacao_4.atividade}}<span> - {{item.ocupacao_4.tecnologia}}</span></li>
                <li>{{item.ocupacao_5.atividade}}<span> - {{item.ocupacao_5.tecnologia}}</span></li>
              </ul>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="timeline__event animated fadeInUp delay-2s timeline__event--type2">
        <div class="timeline__event__icon">
          <fa-icon [icon]="faBriefcase" class="lni-cake"></fa-icon>
        </div>
        <ng-container *ngFor="let item of  third_job">
          <div class="timeline__event__date">
            <p>{{item.dataInicio}}</p>
            <p>até</p>
            <p>{{item.dataFim}}</p>
          </div>
          <div class="timeline__event__content">
            <div class="timeline__event__title">
              {{item.empresa}}
            </div>
            <div class="timeline__event__description">
              <p>{{item.cargo}}</p>
              <ul class="box-text">
                <li>{{item.ocupacao_0.atividade}}<span> - {{item.ocupacao_0.tecnologia}}</span></li>
                <li>{{item.ocupacao_1.atividade}}<span> - {{item.ocupacao_1.tecnologia}}</span></li>
                <li>{{item.ocupacao_2.atividade}}<span> - {{item.ocupacao_2.tecnologia}}</span></li>
              </ul>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="timeline__event animated fadeInUp delay-1s timeline__event--type3">
        <div class="timeline__event__icon">
          <fa-icon [icon]="faBriefcase" class="lni-cake"></fa-icon>
        </div>
        <ng-container *ngFor="let item of second_job">
          <div class="timeline__event__date">
            <p>{{item.dataInicio}}</p>
            <p>até</p>
            <p>{{item.dataFim}}</p>
          </div>
          <div class="timeline__event__content">
            <div class="timeline__event__title">
              {{item.empresa}}
            </div>
            <div class="timeline__event__description">
              <p>{{item.cargo}}</p>
              <ul class="box-text">
                <li>{{item.ocupacao_0.atividade}}<span> - {{item.ocupacao_0.tecnologia}}</span></li>
                <li>{{item.ocupacao_1.atividade}}<span> - {{item.ocupacao_1.tecnologia}}</span></li>
                <li>{{item.ocupacao_2.atividade}}<span> - {{item.ocupacao_2.tecnologia}}</span></li>
                <li>{{item.ocupacao_3.atividade}}<span> - {{item.ocupacao_3.tecnologia}}</span></li>
              </ul>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="timeline__event animated fadeInUp timeline__event--type1">
        <div class="timeline__event__icon">
          <fa-icon [icon]="faBriefcase" class="lni-cake"></fa-icon>
        </div>
        <ng-container *ngFor="let item of first_job">
          <div class="timeline__event__date">
            <p>{{item.dataInicio}}</p>
            <p>até</p>
            <p>{{item.dataFim}}</p>
          </div>
          <div class="timeline__event__content">
            <div class="timeline__event__title">
              {{item.empresa}}
            </div>
            <div class="timeline__event__description">
              <p>{{item.cargo}}</p>
              <ul class="box-text">
                <li>{{item.ocupacao_0.atividade}}<span> - {{item.ocupacao_0.tecnologia}}</span></li>
                <li>{{item.ocupacao_1.atividade}}<span> - {{item.ocupacao_1.tecnologia}}</span></li>
                <li>{{item.ocupacao_2.atividade}}<span> - {{item.ocupacao_2.tecnologia}}</span></li>
                <li>{{item.ocupacao_3.atividade}}<span> - {{item.ocupacao_3.tecnologia}}</span></li>
              </ul>
            </div>
          </div>
        </ng-container>
      </div>

    </div>
  </div>
</section>